<app-menu/>

<div class="row">
  <div class="column shrink mobile-version">
    <a routerLink="/account" class="alert">Продовжити покупки</a>
  </div>
</div>

<div class="row">
  <div class="column">
    <h2>Список побажань</h2>
  </div>
</div>

<div class="row">
  <div class="column">
    <input
      [(ngModel)]="filterFavorites"
      (input)="searchFavorites()"
      type="text"
      placeholder="Пошук по: найменуванню, артикул">
    <label class="search-icon"
           *ngIf="filterFavorites === ''">
    </label>
    <label class="cross-clears-search-field"
           *ngIf="filterFavorites !== ''"
           (click)="crossClearsSearchField()">
    </label>
  </div>
</div>

<div class="page-container">
  <div class="content">
    <div class="row favorites-table-container-row">
      <div class="column" *ngIf="!favorites || favorites.length === 0">
        <h4>Список побажань пустий.</h4>
      </div>
      <div class="favorites-table-container">
        <table *ngIf="favorites && favorites.length > 0">
          <thead>
          <tr>
            <th>Найменування</th>
            <th>Артикул</th>
            <th class="wrap-tooltip-fav">Кіл-ть
              <div class='tooltip'>!</div>
              <div class='bulb'>Додаємо потребність на три місяці
                <div class='bulbarrow'></div>
              </div>
            </th>
            <th>Кіл-ть на складі</th>
            <th></th>
          </tr>
          </thead>
          <tbody *ngFor="let good of filteredFavorites">
          <tr>
            <td class="name fchild">
              <a class="delete" (click)="deleteFavorite(good.pack_id)"></a>
              {{ good.name }}
            </td>
            <td class="article">
              {{ good.article ? good.article.split('|||')[0] : "" }}
            </td>
            <td class="countbasket">
              <div class="buttons-count-to-basket">
                <span class="minus" (click)="minusCount(good)">-</span>
                <span class="number contenteditable"
                      (input)="goodCount(good)"
                      appContenteditable
                      [onlyNumber]="true"
                      [(ngModel)]="good.count"></span>
                <span class="plus" (click)="plusCount(good)">+</span>
              </div>
            </td>
            <td>
              <span *ngIf="good.available > 0">{{ good.available > 9 ? ">10" : good.available }}</span>
              <strong class="no-goods" *ngIf="good.available == 0">Відсутній</strong>
            </td>
            <td>
              <a *ngIf="good.available > 0" (click)="goToGoods(good)" class="button butt-to-basket">Замовити</a>
              <div *ngIf="good.available < 1 && good.waiting === '1' && good.waiting_expect">Очікуємо {{ good.waiting_expect }}<ng-container *ngIf="good.waiting_expect_note"> ({{ good.waiting_expect_note }})</ng-container></div>
            </td>
          </tr>
          </tbody>
        </table>

        <div *ngIf="favorites && favorites.length > 0" class="row clear-btn-container-desktop">
          <div class="clear-list">
            <a (click)="clearAll()" class="button">Очистити список</a>
          </div>
        </div>
      </div>

      <div *ngIf="favorites && favorites.length > 0" class="row clear-list-container">
        <div class="clear-list">
          <a (click)="clearAll()" class="button">Очистити список</a>
        </div>
      </div>
    </div>
  </div>
  <div class="footer-goods mobile-version">
    <footer>
      <small>© 2010-{{ currentYear }}. Всі права захищені.</small>
    </footer>
  </div>
</div>

